const items = document.querySelectorAll('#footer__infos_ID .footer__infos__item'); // tous les items
let itemVisible = document.querySelector('.footer__infos__item.visible'); // l'item initialement visible
let contentVisibles = document.querySelector('.footer__infos__content.visible'); // le contenu initialement visible

function ChangeTab(item) {
    let itemId = item.id.slice(item.id.length - 1);
    let content = document.getElementById('footer__infos__content--' + itemId);

    // si l'item cliqué n'a pas la class visible
    if (!item.classList.contains('visible')) {
        item.classList.add('visible');
        itemVisible.classList.remove('visible');
        contentVisibles.classList.remove('visible');
        content.classList.add('visible');

        // le contenu visible devient celui de l'item' cliqué
        contentVisibles = content;
        itemVisible = item;
    }
}

items.forEach(item => {

    // Au clic la fonction se déclenche
    item.addEventListener('click', () => {
        ChangeTab(item);
    });

    // Avec la navigation au clavier, avec la toucher entrer, la fonction se déclenche
    item.addEventListener('keydown', (e) => {
        if (e.keyCode != 13) {
            return;
        }
        ChangeTab(item);
    });

});
